import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { Chart, ArcElement, PointElement, LinearScale, Title } from 'chart.js';
import { Box } from '@mui/material';

Chart.register(ArcElement, PointElement, LinearScale, Title);

const plugins = [
  {
    beforeDraw(chart) {
      const { width, height, ctx, data } = chart;

      ctx.restore();
      const fontSize = Math.min(width / 100, height / 100);
      ctx.font = ` bolder ${fontSize}em Poppins `;
      ctx.textBaseline = 'middle';
      const text = data.datasets[0].data[0];
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 1.9;
      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  },
];

const responsiveFontForTitle = () => {
  Chart.defaults.font.weight = 600;
  Chart.defaults.font.family = 'Heebo ';
};
if (window.outerWidth > 1700) {
  if (window.outerWidth < 1700 && window.outerWidth > 1440) {
    Chart.defaults.font.size = 13;
  }
  if (window.outerWidth < 1440 && window.outerWidth > 1200) {
    Chart.defaults.font.size = 11;
  }
  if (window.outerWidth < 1200 && window.outerWidth > 900) {
    Chart.defaults.font.size = 9;
  }
  if (window.outerWidth < 900 && window.outerWidth < 600) {
    Chart.defaults.font.size = 7;
  }
}

const Donutchart = ({
  totalOrganization,
  remainingOrganization,
  chartDetails,
}) => {
  const data = {
    labels: ['Total', 'Active'],
    datasets: [
      {
        label: 'My First Dataset',
        data: [totalOrganization, remainingOrganization],
        backgroundColor: ['#9F77EB', '#F1F1F1'],
        weight: 2,
        radius: '50%',
        // borderRadius: 10,
      },
    ],
  };

  const options = {
    cutout: 100,
    responsive: true,
    maintainAspectRatio: false,
    hover: { mode: null },
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: `${chartDetails}`,
        position: 'bottom',
        font: responsiveFontForTitle,
        color: 'rgba(43, 30, 89, 1)',
        padding: -50,
      },
    },
  };

  const config = {
    rotation: 270,
  };
  return (
    <Box>
      <Doughnut
        data={data}
        options={options}
        plugins={plugins}
        config={config}
        style={{
          width: '300px', // Set desired width
          height: '300px', // Set desired height
          // aspectRatio: '240% / 320%', // Set desired aspect ratio
        }}
      />
    </Box>
  );
};

Donutchart.propTypes = {
  totalOrganization: PropTypes.number.isRequired,
  remainingOrganization: PropTypes.number.isRequired,
  chartDetails: PropTypes.string.isRequired,
};

export default Donutchart;
